// Leaves a missing price undefined instead of coercing to 0, so a paid product
// with no price is caught at checkout. A genuinely free product stays 0.
const extractProductPrice = (product) => {
  if (product == null) return undefined
  if (typeof product === 'number') return product
  if (product.price == null) return undefined
  return product.price
}

export default extractProductPrice
